var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"guest-wrapper"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"page-loading"}}),_c('div',{attrs:{"id":"main-wrapper"}},[_c('GuestNavbar'),_c('router-view'),_c('div',{attrs:{"id":"bottom-push"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }